import React from "react";
import Container from "react-bootstrap/Container";
import AmazonCloneImg from "./amazone-cloneImg.jpg";

function Portfolio() {
  return (
    <section className="recruiter-section" id="portfolio" aria-labelledby="projects-title">
      <Container>
        <p className="recruiter-eyebrow">Featured production project</p>
        <h2 id="projects-title">TONearby</h2>
        <p className="recruiter-lede">Toronto recreation discovery. Independently built and shipped.</p>
        <article className="recruiter-feature" aria-label="TONearby case study">
          <div>
            <p>Find Toronto drop-in activities, parks, and community centres using maps,
              geolocation, search, and filters powered by Toronto Open Data.</p>
            <p>I built the mobile apps, website, and backend end-to-end, and shipped
              TONearby to the Apple App Store and Google Play.</p>
            <div className="recruiter-actions">
              <a href="https://tonearby.com">Website</a>
              <a href="https://apps.apple.com/us/app/tonearby/id6766414247">App Store</a>
              <a href="https://play.google.com/store/apps/details?id=com.kordik.tonearby">Google Play</a>
            </div>
            <h3>Engineering behind the product</h3>
            <ul className="recruiter-list">
              <li>Offline-first synchronization with a local outbox and mutation replay;
                server-authoritative writes with Firestore transactions and idempotency.</li>
              <li>Mobile authentication with email/password, Google, and Apple;
                App Check, push notifications, local reminders, and a notification inbox.</li>
              <li>Automated tests with Vitest, Firebase Emulators, and Playwright;
                GitHub Actions and EAS Build / Submit for delivery.</li>
              <li>Production monitoring with Google Analytics 4 (GA4), Firebase Analytics,
                and Crashlytics.</li>
            </ul>
          </div>
          <div className="recruiter-stack" aria-label="TONearby technology stack">
            <div><h3>Mobile</h3><p>React Native 0.81 · Expo SDK 54 · React · TypeScript</p><span>iOS + Android</span></div>
            <div><h3>Web</h3><p>Next.js 16 · React · TypeScript · Tailwind CSS · Leaflet</p><span>Static export, SEO facility pages, Firebase Hosting</span></div>
            <div><h3>Backend</h3><p>Firebase Cloud Functions v2 · Node.js · TypeScript · Cloud Firestore</p><span>Firebase Auth + App Check</span></div>
          </div>
        </article>
      </Container>
    </section>
  );
}

export function OtherProjects() {
  return (
    <section className="recruiter-section recruiter-other" aria-labelledby="other-projects-title">
      <Container>
        <details>
          <summary id="other-projects-title">Other Projects — earlier learning work</summary>
          <article className="recruiter-demo">
            <img src={AmazonCloneImg} alt="Amazon Clone learning project preview" loading="lazy" width="420" />
            <div><h3>Amazon Clone</h3>
              <p>A personal React and Firebase learning project exploring authentication,
                product browsing, cart state, and Stripe test payments.</p>
              <p>Demo only. No real purchases. Some browsers may flag the Amazon-like interface.</p>
              <a href="https://clone-72fc6.web.app/">View learning demo</a>
            </div>
          </article>
        </details>
      </Container>
    </section>
  );
}
export default Portfolio;
